<div class="add-location-dialog">
  <miq-global-selection
    [selectedPermissions]="permissionRecord"
    (advancedSearchEmitter)="openSubselection($event)"
    (addPermissionEmitter)="setUserPermissions($event)"
    >
  </miq-global-selection>

  @if (showItems === true) {
    <div class="sub-selection">
      <div class="district-dropdown">
        <miq-sub-selection
          [selectedFilter]="'shared.district' | translate"
          [subSectionList]="districtsList"
          [editPermissionList]="district"
          [InputLength]="selectedMarketsCount"
          (selectedProperty)="selectedDistricts($event)"
          >
        </miq-sub-selection>
      </div>
      <div class="neighrbour-hood">
        <miq-sub-selection
          [selectedFilter]="'shared.neighborhood' | translate"
          [subSectionList]="neighborhoodList"
          [editPermissionList]="neighborhood"
          [InputLength]="selectedNeighborCount"
          (selectedProperty)="selectedNeighbourhood($event)"
          >
        </miq-sub-selection>
      </div>
    </div>
  }
  <div [formGroup]="formGroup" (ngSubmit)="addPermission()" class="confidentiality-container">
    <table aria-hidden="true">
      <thead class="export-labels">
        <tr>
          <th scope="col" translate>
            {{ 'shared.confidentiality' | translate | titlecase }}
            <mat-icon class="info-icon">info</mat-icon>
          </th>
          <!-- Add an asterisk -->
          <th scope="col" translate>
            {{ 'shared.businessJustificationS' | translate | titlecase }} <span class="required-icon">*</span>
          </th>
        </tr>
      </thead>
      <tbody class="export-input">
        <tr>
          <th scope="col" class="confidentiality">
            <mat-form-field floatLabel="never" appearance="outline" style="width: 100%">
              <mat-select [formControl]="confidentialityFC" disableOptionCentering>
                @for (level of confidentialityLevels; track level) {
                  <mat-option [value]="level">
                    {{ level.value }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </th>
          <th scope="col" class="justification">
            <mat-form-field class="business-justification" appearance="outline">
              <textarea
                matInput
                autocomplete="no-autofill"
                [placeholder]="'shared.250CharactersLess' | translate"
                class="text-area"
                [formControl]="businessJustification"
                >
              </textarea>
              @if (businessJustification.hasError('required')) {
                <mat-error>
                  {{ 'shared.businessJustificationNeeded' | translate }}
                </mat-error>
              }
              @if (businessJustification.hasError('maxlength')) {
                <mat-error>
                  {{ 'shared.businessJustificationLessThanChars' | translate }}
                </mat-error>
              }
            </mat-form-field>
          </th>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="type-length">
    <mat-hint>{{ businessJustification.value?.length || 0 }}/250</mat-hint>
  </div>

  <div mat-dialog-actions>
    <button
      type="submit"
      value="submit"
      class="btn-submit-100"
      (click)="addPermission()"
      [disabled]="formGroup.invalid || invalidUserPermissions"
      >
      @if (permissionRecord) {
        <span> {{ 'shared.save' | translate }}</span>
      } @else {
        <span> {{ 'shared.sAdd' | translate }}</span>
      }
    </button>
  </div>
</div>
